define('lib/leaflet-background-map-selector/leaflet-background-map-selector',['leaflet'], function() {
  'use strict';

  L.Control.BackgroundMapSelector = L.Control.extend({
    // default options
    options: {
      config: {},
      title: 'Välj bakgrundslager',
      backgroundMaps: [],
    },

    initialize: function(options) {
      L.Util.setOptions(this, options || {});

      this._config = this.options.config;
      this._mapDefinitions = this._config.mapDefinitions;
      this._layerDefinitions = this._config.layerDefinitions;
    },

    onAdd: function(map) {
      var self = this;
      this._map = map;
      this._container = L.DomUtil.create('div', 'lbms__container');
      this._trigger = L.DomUtil.create('a', 'leaflet-bar lbms__trigger', this._container);
      this._selectArea = L.DomUtil.create('div', 'lbms__select-area', this._container);
      this._bgLayerGroups = [];
      this._activeBgLayerGroupIndex = 0;

      L.DomUtil.create('i', 'fas fa-globe-americas fa-lg', this._trigger);
      this._trigger.title = this.options.title;
      L.DomEvent.on(this._trigger, 'click', this._toggleSelectArea.bind(this), this._trigger);

      this._map.createPane('bgMapsPane');
      this._map.getPane('bgMapsPane').style.zIndex = 100;
      this._map.getPane('bgMapsPane').style.pointerEvents = 'none';

      this._populateLayers();
      this._setBackgroundLayer(0);

      // close select area when clicking outside
      this._map.on('click', function(event) {
        var clickedTarget = event.originalEvent.target;
        // when clicking on for example a polygon, className is an object, causing error when trying to do .indexOf()
        if (typeof clickedTarget.className !== 'string') {
          self._selectArea.style.display = 'none';
          return;
        }

        var clickIsOnMap = clickedTarget.className.indexOf('leaflet') > -1;
        var selectAreaIsShown = self._selectArea.style.display === 'block';
        if (!clickIsOnMap || !selectAreaIsShown) {
          return;
        }

        self._selectArea.style.display = 'none';
      });

      return this._container;
    },

    addTo: function(map) {
      L.Control.prototype.addTo.call(this, map);
      return this;
    },

    _toggleSelectArea: function() {
      if (!this._selectArea.style.display || this._selectArea.style.display === 'none') {
        this._selectArea.style.display = 'block';
        this._markThumbnailAsSelected(this._activeBgLayerGroupIndex);
      } else {
        this._selectArea.style.display = 'none';
      }
    },

    _hideSelectArea: function() {
      this._selectArea.style.display = 'none';
    },

    _populateLayers: function() {
      var self = this;
      var backgroundMaps = self.options.backgroundMaps || [];
      var noLayersFound = false;

      backgroundMaps.forEach(function(bgMap, index) {
        var mapDefinition = self._mapDefinitions[bgMap];
        if (!mapDefinition) {
          console.debug('map does not exist in config', bgMap);
          return;
        }

        var layers = [];
        var title = mapDefinition.title || '';
        var image = mapDefinition.image || '';

        // just a safe guard if layers prop is missing
        if (!mapDefinition.layers || !mapDefinition.layers.length) {
          mapDefinition.layers = [];
          noLayersFound = true;
        }

        mapDefinition.layers.forEach(function(layer, layerIndex) {
          var layerDefinition = self._layerDefinitions[layer.layerDefinitionId];
          if (!layerDefinition) return;

          if (layerIndex === 0) {
            // create thumbnail
            var thumbnail = L.DomUtil.create('div', 'lbms__thumbnail', self._selectArea);
            thumbnail.title = title;
            thumbnail.style.backgroundImage = 'url(' + self._config.baseImageUrl + image + ')';
            L.DomEvent.on(
              thumbnail,
              'click',
              self._setBackgroundLayer.bind(self, index),
              thumbnail
            );
          }

          layers.push(self._createLayer(layerDefinition, layer));
        });

        if (layers.length) {
          self._bgLayerGroups.push(layers);
        }
      });

      // if we weren't able to find any bglayers, fallback to default
      if (!self._bgLayerGroups.length && !noLayersFound) {
        var firstPropertyInMapDefinitions = Object.keys(self._mapDefinitions)[0];
        this.options.backgroundMaps = [firstPropertyInMapDefinitions];
        this._populateLayers();
        L.DomUtil.setClass(self._container, 'lbms__container--hidden');
      }

      if (self._bgLayerGroups.length < 2) {
        this._hideDomElements();
      }
    },

    _markThumbnailAsSelected: function(index) {
      var thumbnail = document.querySelectorAll('.lbms__thumbnail')[index];
      if (!thumbnail) return;

      if (this._checkIcon) {
        L.DomUtil.remove(this._checkIcon);
      }
      this._checkIcon = L.DomUtil.create('i', 'fas fa-check', thumbnail);
    },

    _hideDomElements: function() {
      L.DomUtil.remove(this._container);
      L.DomUtil.remove(this._trigger);
    },

    _createLayer: function(layerDefinition, layer) {
      var options = layerDefinition.extraOptions || {};
      options.minZoom = layer.minZoom;
      options.maxZoom = layer.maxZoom;
      options.attribution = layerDefinition.attribution;

      if (layerDefinition.type === 'tile') {
        return L.tileLayer(layerDefinition.baseUrl, options);
      } else {
        options.layers = layerDefinition.layerName;
        options.format = 'image/png';
        options.transparent = true;
        return L.tileLayer.wms(layerDefinition.baseUrl, options);
      }
    },

    _setBackgroundLayer: function(index) {
      if (typeof index === 'undefined' || index < 0) {
        return;
      }
      if (this._activeBgLayerGroup) {
        this._activeBgLayerGroup.removeFrom(this._map);
      }

      this._activeBgLayerGroupIndex = index;
      this._activeBgLayerGroup = L.layerGroup(this._bgLayerGroups[index], { pane: 'bgMapsPane' });
      this._activeBgLayerGroup.addTo(this._map);

      this._markThumbnailAsSelected(index);
    },
  });

  return L.Control.BackgroundMapSelector;
});

